module.exports = __webpack_public_path__ + "static/img/W_BAGS.b7a3823.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/W_BAGS.jpg
// module id = Aq/L
// module chunks = 1